import { render, staticRenderFns } from "./boutique.vue?vue&type=template&id=aee88350&scoped=true&"
import script from "./boutique.vue?vue&type=script&lang=js&"
export * from "./boutique.vue?vue&type=script&lang=js&"
import style0 from "./boutique.vue?vue&type=style&index=0&id=aee88350&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aee88350",
  null
  
)

export default component.exports